module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_6-b8952e179a1c6ea2c69125dc5fe898ee.jpg";